import { toJalaali } from 'jalaali-js';

const PERSIAN_MONTHS = [
  'فروردین',
  'اردیبهشت',
  'خرداد',
  'تیر',
  'مرداد',
  'شهریور',
  'مهر',
  'آبان',
  'آذر',
  'دی',
  'بهمن',
  'اسفند',
];

function addJalaliMonths(jy: number, jm: number, offset: number) {
  let year = jy;
  let month = jm + offset;

  while (month > 12) {
    month -= 12;
    year++;
  }

  while (month < 1) {
    month += 12;
    year--;
  }

  return { jy: year, jm: month };
}

export const usePeriodicFilterItems = () => {
  const today = new Date();
  const { jy, jm } = toJalaali(today);

  const items = Array.from({ length: 12 }, (_, i) => {
    const offset = i - 10; // -10 → +1
    const { jy: year, jm: month } = addJalaliMonths(jy, jm, offset);

    return {
      id: `${year}-${month}`,
      month: `${PERSIAN_MONTHS[month - 1]}`,
      year: `${year}`,
      isDisabled: offset === 1,
    };
  });

  return { items };
};
